
import React from 'react';
import { ChevronRight } from 'lucide-react';
import { CategoryHeaderActions } from './CategoryHeaderActions';

interface CategoryItemHeaderProps {
  name: string;
  isExpanded: boolean;
  hasChildren: boolean;
  onClick: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  isOver?: boolean;
  canDrop?: boolean;
  level: number;
  onMoveUp?: () => void;
  onMoveDown?: () => void;
  isFirst?: boolean;
  isLast?: boolean;
  hasLinkedAccounts?: boolean;
  isSelected?: boolean;
  type?: 'Afdracht' | 'Geen afdracht';
}

export const CategoryItemHeader: React.FC<CategoryItemHeaderProps> = ({
  name,
  isExpanded,
  hasChildren,
  onClick,
  onEdit,
  onDelete,
  isOver,
  canDrop,
  level,
  onMoveUp,
  onMoveDown,
  isFirst,
  isLast,
  hasLinkedAccounts,
  isSelected,
  type
}) => {
  return (
    <div 
      className={`
        flex items-center justify-between p-1.5 cursor-pointer
        ${isOver && canDrop ? 'bg-blue-50' : ''}
        ${isSelected ? 'bg-orange-100 text-orange-900 font-medium' : 'hover:bg-gray-50'}
        transition-all duration-200 relative
      `}
      data-testid="category-header"
      data-selected={isSelected ? 'true' : 'false'}
    >
      <div className="flex items-center gap-1.5 flex-1">
        <button
          onClick={onClick}
          className="p-0.5 hover:bg-gray-200 rounded-full transition-colors"
          data-expand-button
        >
          <ChevronRight
            className={`h-3 w-3 transition-transform ${isExpanded ? 'rotate-90' : ''} 
              ${!hasChildren ? 'opacity-0' : ''}`}
          />
        </button>
        
        <span className={`font-medium text-sm ${isSelected ? 'text-orange-800' : 'text-[#000000e6]'}`}>
          {name}
        </span>

        {type && (
          <span className={`ml-2 text-xs px-1.5 py-0.5 rounded font-medium
            ${type === 'Afdracht' 
              ? 'bg-blue-100 text-blue-700' 
              : 'bg-green-100 text-green-700'
            }`}
          >
            {type === 'Afdracht' ? 'A' : 'GA'}
          </span>
        )}
      </div>

      <CategoryHeaderActions
        onEdit={onEdit}
        onDelete={onDelete}
        onMoveUp={onMoveUp}
        onMoveDown={onMoveDown}
        isFirst={isFirst}
        isLast={isLast}
        hasLinkedAccounts={hasLinkedAccounts}
        isSelected={isSelected}
      />
    </div>
  );
};
